import { render, staticRenderFns } from "./UserReview.vue?vue&type=template&id=56a2dfd2&lang=pug"
import script from "./UserReview.vue?vue&type=script&lang=js"
export * from "./UserReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports